import ArtifactWebView from '@/modules/artifacts/ArtifactWebView'
import { useLocalSearchParams } from 'expo-router'
import { Platform, View } from 'react-native'
import { useSafeAreaInsets } from 'react-native-safe-area-context'

export default function ArtifactPage() {
  const insets = useSafeAreaInsets()
  const { token } = useLocalSearchParams<{ token: string }>()

  return (
    <View className="flex-1" style={Platform.OS === 'android' ? { paddingBottom: insets.bottom } : undefined}>
      <ArtifactWebView token={token} />
    </View>
  )
}
